module.exports = "/cyber/_next/static/images/snowflake-66b1685745c7f50a83784dd74cdf5895.png";